export const oauthClientParams = {
  client_id: 'api_client_id',
  client_secret: 'api_client_secret'
};

export const validationConfigs = {
  orderFile: {
    types: ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'],
    size: 10 // Mb
  }
};

export const tokenRefreshInterval = 900000; // 15 minutes
export const itemsPerPage = 20;

export const numbersPattern = /^[+]\d+$/;
// tslint:disable-next-line
export const emailPattern: RegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`\{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;


// WEBPACK FOOTER //
// ./src/app/configs.ts